module.exports = __webpack_public_path__ + "img/历程背景.fc3b5142.png";